import React from 'react';
import PropTypes from 'prop-types';

import Notification from './components/Notification';

import './Notifications.css';

const renderNotifications = notifications => {
  return notifications.map(n => {
    return <Notification key={`notification_${n.id}`} text={n.text} icon={n.icon} />;
  });
};

export default function Notifications({ notifications }) {
  const notificationsList = Object.values(notifications);

  if (!notificationsList.length) return null;

  return <div className="MapNotifications">{renderNotifications(notificationsList)}</div>;
}
Notifications.propTypes = {
  notifications: PropTypes.object,
};
Notifications.defaultProps = {
  notifications: {},
};



// WEBPACK FOOTER //
// ../ui-components/components/MapNotifications/Notifications.jsx